import React from 'react';
import { Route, Switch } from 'react-router-dom';
import List from './List';
import Show from './Show';
import New from './New';
import Exam from './Exam';
import Edit from './Edit';
import ShowEvent from './ShowEvent';
import { PeoplesProvider } from './context';
import { RoutesProvider } from './context/routesContext';
import Can from '~/contexts/Can';
import NotPermissionPage from '~/pages/NotPermissionPage';

import {
  showPerson,
  showEvent,
  editPerson,
  newPerson,
  examsPerson,
} from '../../config/routes';

function Peoples() {
  return (
    <PeoplesProvider>
      <RoutesProvider>
        <Switch>
          <Route
            exact
            path={showEvent.spec}
            render={(props) => (
              <>
                <Can I="event_show" a="Peoples">
                  {() => <ShowEvent {...props} />}
                </Can>
                <Can not I="event_show" a="Peoples">
                  {() => <NotPermissionPage />}
                </Can>
              </>
            )}
          />

          <Route
            exact
            path={showPerson.spec}
            render={(props) => (
              <>
                <Can I="show" a="Peoples">
                  {() => <Show {...props} />}
                </Can>
                <Can not I="show" a="Peoples">
                  {() => <NotPermissionPage />}
                </Can>
              </>
            )}
          />

          <Route
            exact
            path={editPerson.spec}
            render={(props) => (
              <>
                <Can I="edit" a="Peoples">
                  {() => <Edit {...props} />}
                </Can>
                <Can not I="edit" a="Peoples">
                  {() => <NotPermissionPage />}
                </Can>
              </>
            )}
          />

          <Route
            exact
            path={newPerson.spec}
            render={(props) => (
              <>
                <Can I="new" a="Peoples">
                  {() => <New {...props} />}
                </Can>
                <Can not I="new" a="Peoples">
                  {() => <NotPermissionPage />}
                </Can>
              </>
            )}
          />

          <Route
            exact
            path={examsPerson.spec}
            render={(props) => (
              <>
                <Can I="exam" a="Peoples">
                  {() => <Exam {...props} />}
                </Can>
                <Can not I="exam" a="Peoples">
                  {() => <NotPermissionPage />}
                </Can>
              </>
            )}
          />

          <Route
            render={(props) => (
              <>
                <Can I="list" a="Peoples">
                  {() => <List {...props} />}
                </Can>
                <Can not I="list" a="Peoples">
                  {() => <NotPermissionPage />}
                </Can>
              </>
            )}
          />
        </Switch>
      </RoutesProvider>
    </PeoplesProvider>
  );
}
export default React.memo(Peoples);
